import { FileList } from "/@/components/FileList";

export const PanelMain: React.FC = () => {
  return <FileList />;
};
